import {createSelector} from 'reselect';
import props from '../props';

export default createSelector(
    props.user.user,
    props.user.kyc_profile,
    (user, kyc_profile) => {
        return {
            user,
            kyc_profile
        }
    }
)